<template>
  <div id="Schools" class="wrap">
    <v-app-bar prominent class="white d-md-none" fixed elevate-on-scroll>
      <v-layout column align-center justify-center>
        <div
          class="text-center font-weight-medium light-blue--text text--darken-4"
        >
          <h2
            class="headline font-weight-regular boldText mt-3"
          >
            <span class="yellow__text font-weight-bold display-1">{{
              filteredSchools.length
            }}</span>
            PA Schools
          </h2>
        </div>

        <v-layout pt-1 mb-0 row align-baseline style="width: 100%">
          <v-autocomplete
            v-model="model"
            label="search "
            :items="verifiedSchools"
            item-value="id"
            item-text="school_name"
            outlined
            clearable
            prepend-inner-icon="mdi-magnify"
            single-line
            class="mx-1 mt-2 col-md-6 "
            color="light-blue darken-4"
          >
            <template slot="item" slot-scope="data">
              <v-list-item-avatar>
                <img :src="data.item.program_image" />
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  v-html="data.item.school_name"
                ></v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-layout>
      </v-layout>
    </v-app-bar>

    <v-layout
      class="hidden-sm-and-down"
      mb-0
      column
      justify-center
      align-center
    >
      <div
        class="text-center font-weight-medium light-blue--text text--darken-4 mb-2"
      >
        <v-layout column justify-center align-center>
          <span
            class="yellow__text  font-weight-regular display-3"
            >{{ filteredSchools.length }}</span
          >
          <h2 class="headline font-weight-bold boldText">
            PA Schools
          </h2>
        </v-layout>
      </div>
      <v-autocomplete
        v-model="model"
        label="search "
        :items="verifiedSchools"
        item-value="id"
        item-text="school_name"
        outlined
        clearable
        prepend-inner-icon="mdi-magnify"
        hide-details
        single-line
        class="mx-1 mt-2 col-md-6"
        color="light-blue darken-4"
        style="width: 100%"
      >
        <template slot="item" slot-scope="data">
          <v-list-item-avatar>
            <img :src="data.item.program_image" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              v-html="data.item.school_name"
            ></v-list-item-title>
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </v-layout>

    <v-card flat class="pb-5 mb-5 schoolsCard">
      <!-- PA Schools List -->
      <PaSchoolsList
        v-if="showFilter === false"
        :filteredSchools="filteredSchools"
      />
    </v-card>

    <v-layout
      v-if="schools.length <= 0"
      column
      align-center
      justify-center
      mt-4
    >
      <v-progress-circular
        :size="100"
        color="primary"
        indeterminate
      ></v-progress-circular>
      <span class="mt-4 subheading font-weight-regular grey--text"
        >Loading Schools</span
      >
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      model: "",
      showFilter: false,
      dialog: false,
      searchStatus: "Any Status",
      searchPaShadowing: this.maxPaShadowingHours,
      searchState: "All States",
      searchMinGpa: "",
      searchOverallGpa: 4.0,
      searchScienceGpa: 4.0,
      healthcareExperience: "",
      minimumHealthcareHours: "",
      paShadowing: "",
      gre: "",

      states: [
        "All States",
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District of Columbia",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
      ],
    };
  },
  computed: {
    schools() {
      return this.$store.getters.loadedSchools;
    },
    verifiedSchools() {
      return this.schools.filter((school) => {
        if (school.verified === true) {
          return school;
        } else {
          return false;
        }
      });
    },

    filteredSchools() {
      return this.schools
        .filter((school) => {
          if (school.verified === true) {
            return true;
          } else {
            return false;
          }
          if (this.searchState !== "" && this.searchState !== "All States") {
            return school.program_state === this.searchState;
          } else {
            return true;
          }
          if (this.searchState === "All States") {
            return true;
          }
        })
        .filter((school) => {
          if (this.searchStatus !== "" && this.searchStatus !== "Any Status") {
            return school.accreditation_status === this.searchStatus;
          } else {
            return true;
          }
          if (this.searchStatus === "Any Status") {
            return true;
          }
        })
        .filter((school) => {
          if (this.paShadowing === "not required") {
            return (
              school.pa_shadowing_required === false &&
              school.pa_shadowing_recommended === false
            );
          }
          // PA Shadowing Recommended
          if (this.paShadowing === "recommended") {
            return (
              school.pa_shadowing_recommended === true &&
              school.pa_shadowing_required === false
            );
          }
          // PA Shadowing Required
          if (this.paShadowing === "required") {
            return (
              school.pa_shadowing_required === true &&
              school.pa_shadowing_recommended === false
            );
          } else {
            return true;
          }
        })
        .filter((school) => {
          if (this.gre === "required") {
            return school.gre_required === true;
          }
          if (this.gre === "not required") {
            return school.gre_required === false;
          } else {
            return true;
          }
        })

        .filter((school) => {
          if (this.searchMinGpa === "required") {
            return school.gpa_minimum_required === true;
          }

          if (this.searchMinGpa === "not required") {
            return school.gpa_minimum_required === false;
          } else {
            return true;
          }
        })
        .filter((school) => {
          if (
            this.searchMinGpa === "required" &&
            school.gpa_overall_minimum !== ""
          ) {
            return (
              school.gpa_overall_minimum <= parseInt(this.searchOverallGpa)
            );
          } else {
            return true;
          }
        })
        .filter((school) => {
          if (
            this.searchMinGpa === "required" &&
            school.gpa_science_minimum !== ""
          ) {
            return (
              school.gpa_science_minimum <= parseInt(this.searchScienceGpa)
            );
          } else {
            return true;
          }
        })
        .filter((school) => {
          if (this.healthcareExperience === "not required") {
            return (
              school.healthcare_experience_required === false &&
              school.healthcare_experience_recommended === false
            );
          }

          if (this.healthcareExperience === "recommended") {
            return (
              school.healthcare_experience_recommended === true &&
              school.healthcare_experience_required === false
            );
          }

          if (this.healthcareExperience === "required") {
            return (
              school.healthcare_experience_required === true &&
              school.healthcare_experience_recommended === false
            );
          } else {
            return true;
          }
        });
    },
    maxPaShadowingHours() {
      let maxShadowingHours = [];
      this.schools.filter((school) => {
        if (
          school.pa_shadowing_required &&
          school.pa_shadowing_minimum_hours !== ""
        ) {
          maxShadowingHours.push(school.pa_shadowing_minimum_hours);
        }
      });
      return Math.max.apply(null, maxShadowingHours);
    },
    maxHealthcareHours() {
      let maxHealthcareHours = [];
      this.schools.filter((school) => {
        if (
          school.healthcare_experience_required &&
          school.healthcare_experience_minimum_hours !== ""
        ) {
          maxHealthcareHours.push(school.healthcare_experience_minimum_hours);
        }
      });
      console.log(maxHealthcareHours);
      return Math.max.apply(null, maxHealthcareHours);
    },
  },
  methods: {
    moreInfo(id) {
      this.$router.push("/schools/" + id);
    },
    viewSchool() {
      // this.$router.push("/schools/" + this.model);
    },
    cancelFilter() {
      (this.searchState = this.searchState),
        (this.searchStatus = this.searchStatus),
        (this.showFilter = false);
    },
    clearFilter() {
      (this.searchState = "All States"),
        (this.searchStatus = "Any Status"),
        (this.searchPaShadowing = this.maxPaShadowingHours),
        (this.paShadowing = ""),
        (this.searchMinGpa = ""),
        (this.searchOverallGpa = 4.0),
        (this.searchScienceGpa = 4.0),
        (this.healthcareExperience = "");
    },
  },
  watch: {
    model() {
      if (
        this.model !== "" &&
        this.model !== undefined &&
        this.model !== null
      ) {
        const findSchool = this.verifiedSchools.find(school => school.id === this.model);
     
        this.$router.push("/paschool/" + findSchool.school_name.split(' ').join('-'));
       
      }

     
    },
  },
};
</script>

<style scoped>
.buttonFixed {
  position: fixed;
  bottom: 0;
  left: 0;
}

.fixed {
  position: fixed;
}

.fixedHeader {
  position: fixed;

  display: flex;
  align-items: center;
  justify-content: center;
}

#buttonShadow {
  position: sticky;
  box-shadow: 0 20px 20px -18px rgba(33, 36, 39, 0.164);

  /* -webkit-box-shadow: 0 4px 8px 0 rgba(0,0,0,0.18);
	-moz-box-shadow: 0 4px 8px 0 rgba(0,0,0,0.18);
	box-shadow: 0 4px 8px 0 rgba(0,0,0,0.18); */
}

.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
}
#backButton {
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.19);
}

img {
  width: 35px;
  height: 35px;
}

@media (max-width: 900px) {
  .schoolsCard {
    margin-top: 40px;
  }
}

.wrap {
   padding-top:10vh;
}

.yellow__text {
  color: #D49129;
}

.boldText {
    color: #005880;
}
</style>



// WEBPACK FOOTER //
// src/components/Schools/PaSchools.vue